"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FudaoDefinition_1 = require("../FudaoDefinition");
class NullFudaoSessionFacade {
    async RequestToStartSessionAsync(fst, creatorFudaoUser, attendeeFudaoUsers) {
        return FudaoDefinition_1.FudaoSession.Create("NullSessionId", fst);
        //return FudaoSession.INVALID_FUDAO_SESSION;
    }
    async StartSessionAsync(fs, teacher, videoContainer) { }
    async StartDataSessionAsync(fs, teacher, localDataProvider, remoteDataReceiver) { }
    async JoinSessionAsync(fs, student, videoContainer) { }
    async JoinDataSessionAsync(fs, student, localDataProvider, remoteDataReceiver) { }
    async StopSessionAsync(fs, teacher) { }
    async ExitSessionAsync(fs, fudaoUser) { }
    SwitchSessionNextVideoSource(fs, teacher) { }
}
exports.NullFudaoSessionFacade = NullFudaoSessionFacade;
exports.NullFudaoSessionFacadeSingleton = new NullFudaoSessionFacade();
//# sourceMappingURL=NullFudaoSessionFacade.js.map